import { Link } from "react-router-dom";
import aiVideoAdsImg from "@/assets/ai video ads.jpeg";
import socialMediaManagementImg from "@/assets/social media managment.jpeg";
import videoEditingImg from "@/assets/video editing.jpeg";

const trendingServices = [
  { 
    title: "Ad Video Creatives", 
    slug: "video-editing", 
    excerpt: "Engaging AI-powered video ads designed to capture attention and promote your brand effectively.", 
    image: aiVideoAdsImg 
  },
  { 
    title: "Social Media Management", 
    slug: "social-media", 
    excerpt: "Professional management of your social media to keep your brand active and growing online.", 
    image: socialMediaManagementImg 
  },
  { 
    title: "Video Editing", 
    slug: "video-editing", 
    excerpt: "High-quality video editing that makes your content more engaging and visually appealing. 🚀", 
    image: videoEditingImg 
  },
];

const TrendingServicesSection = () => {
  return (
    <section id="trending-services" className="py-12 md:py-20 bg-surface-alt">
      <div className="container mx-auto px-4">
        <div className="text-center mb-8 md:mb-12">
          <span className="inline-block px-5 py-2 rounded-full gradient-cta text-primary-foreground text-xs font-semibold tracking-widest uppercase mb-4">
            Our Services
          </span>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-primary mb-4">
            Trending Services
          </h2>
          <p className="text-muted-foreground text-sm md:text-base">
            Explore our most in-demand services that help brands grow faster and stand out in the digital world. At Graphic Lines, we deliver creative solutions that attract attention and drive results.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-6 md:gap-8 max-w-5xl mx-auto">
          {trendingServices.map((service, index) => (
            <Link key={`${service.slug}-${index}`} to={`/services/${service.slug}`} className="group bg-card border border-border rounded-2xl overflow-hidden hover:shadow-xl hover:-translate-y-1 transition-all duration-200">
              <div className="h-40 md:h-52 overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="p-4 md:p-6">
                <h3 className="text-sm md:text-base font-bold text-primary mb-2 group-hover:underline leading-tight">
                  {service.title}
                </h3>
                <p className="text-xs md:text-sm text-muted-foreground leading-relaxed mb-3 md:mb-4 line-clamp-3">
                  {service.excerpt}
                </p>
                <span className="text-xs md:text-sm font-semibold text-primary inline-flex items-center gap-1">
                  Read More <span>→</span>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrendingServicesSection;
